import React from 'react';
import s from './Brands.module.scss';
import { useNavigate } from 'react-router-dom';
import useGetAllBrands from 'sdk/hooks/shop/useGetAllBrands';
import BrandCard from './BrandCard';
import { useTranslation } from 'react-i18next';
import ForwardArrow from 'modules/app/components/UI/ForwardArrow';

const Products = () => {
  const { data: brands } = useGetAllBrands();
  const navigate = useNavigate();
  const {t} = useTranslation() as any
  const servicesTitle = (text) => (
    <div className={s.services_title}>
      <div className={s.services_title_title}>{text}</div>
      <div className={s.services_title_see}>
        <div onClick={() => navigate('/all-brands')}>{t('See All')}</div>
        <ForwardArrow />
      </div>
    </div>
  );

  return (
    <div className={s.container}>
      {servicesTitle(t('Brands'))}
      <div className={s.products}>
        <div className={s.grid}>
          {brands?.map((item) => (
            <BrandCard key={item.id} id={item.id} logo={item.logo} name={item.name} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Products;
